module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/96652c3aa2000c0f09d142e5e169c6f0.png";